// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ida8","content":"styles_content__bCMyI","selectAll":"styles_selectAll__3Zbw9"};